import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-section-free-mock',
  standalone: true,
  imports: [RouterModule,CommonModule],
  templateUrl: './section-free-mock.component.html',
  styleUrl: './section-free-mock.component.css'
})
export class SectionFreeMockComponent {

  @Input() title: string = "";
}
